import React, { Component } from 'react'
import { getTheme, viewportWidth } from 'helpers'
import styled from 'styled-components'
import HorizontalCentered from 'components/HorizontalCentered'
import VerticalCentered from 'components/VerticalCentered'
import svgLoading from 'assets/svg/icon-loading.svg'
import svgLoadingTiffany from 'assets/svg/icon-loading-tiffany.svg'
import svgClose from 'assets/svg/icon-close.svg'
import svgLeft from 'assets/svg/icon-left.svg'

export default class extends Component {
  render () {
    const { title, style, auto, onBack, onClose, children, noPadding } = this.props
    return (
      <Modal style={style} auto={auto} onClick={e => e.stopPropagation()}>
        <ModalTitle>
          {onBack && (
            <ModalBack onClick={onBack}>
              <IconLeft src={svgLeft} />
            </ModalBack>
          )}
          <span>{title}</span>
          <ModalClose onClick={onClose}>
            <IconClose src={svgClose} />
          </ModalClose>
        </ModalTitle>
        <ModalBody noPadding={noPadding}>{children}</ModalBody>
      </Modal>
    )
  }
}

const Modal = styled.div`
  width: ${props => props.auto ? 'auto' : 'calc(100vw - 20px)'};
  height: ${props => props.auto ? 'auto' : 'calc(100vh - 40px)'};
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  text-align: left;
  white-space: initial;
`
const ModalBody = styled.div`
  padding: ${props => props.noPadding ? 0 : 20}px;
`
const ModalBack = styled.div`
  height: 40px;
  width: 40px;
  text-align: left;
  position: absolute;
  top: 0px;
  left: 0px;
  cursor: pointer;
`
const IconLeft = styled.img`
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px;
  margin-left: 5px;
`

export class Overlay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      zIndex: props.visible ? 15000 : -1,
      display: props.visible ? 'block' : 'none'
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.visible !== nextProps.visible) {
      document.getElementsByTagName('html')[0].style.overflow = nextProps.visible ? 'hidden' : null
      if (nextProps.visible) {
        this.setState({ zIndex: 15000, display: 'block' })
      } else {
        setTimeout(() => this.setState({ zIndex: -1, display: 'none' }), 300)
      }
    }
  }

  render () {
    const { style = {}, onClose, children, visible } = this.props
    return (
      <OverlayWrapper visible={visible} style={{ ...style, zIndex: this.state.zIndex, display: this.state.display }} onClick={onClose}>
        {children}
      </OverlayWrapper>
    )
  }
}

export const OverlayWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  ${props => props.visible ? `
    opacity: 1;
  ` : `
    opacity: 0;
  `}
`
export const Loading = () =>
  <HorizontalCentered>
    <VerticalCentered>
      <IconLoading src={svgLoading} />
    </VerticalCentered>
  </HorizontalCentered>

const IconLoading = styled.img`
  width: 60px;
  height: 60px;
  vertical-align: top;
  filter: brightness(0) invert(1);
`

export class ActionSheets extends Component {
  render () {
    return this.props.withoutOverlay ? (
      <RActionSheets {...this.props} />
    ) : (
      <Overlay visible={this.props.visible} onClick={this.props.onCancel}>
        <RActionSheets {...this.props} />
      </Overlay>
    )
  }
}
const RActionSheets = ({ desktopStyle, visible, onClick, title, options, onCancel, cancelTitle, loading, topRight }) => {
  return viewportWidth() < 768 ? (
    <ActionSheetsWrapper onClick={e => e.stopPropagation()}>
      {loading ? (
        <Loading />
      ) : (
        <MobileButtons visible={visible}>
          <ButtonGroup>
            {title && <ButtonGroupHead>{title}</ButtonGroupHead>}
            {(options || []).map(({ key, onClick, color, title, icon }) =>
              <Button color={icon ? 'black' : color} key={key} onClick={onClick}>
                {icon && <Icon src={icon} />}
                <span>{title}</span>
              </Button>
            )}
          </ButtonGroup>
          <Button color='black' onClick={onCancel}>{cancelTitle || 'ย้อนกลับ'}</Button>
        </MobileButtons>
      )}
    </ActionSheetsWrapper>
  ) : (visible && topRight) ? (
    <ActionSheetsWrapper topRight onClick={e => e.stopPropagation()}>
      {loading ? (
        <Loading />
      ) : (
        <div>
          {title && <ButtonGroupHead>{title}</ButtonGroupHead>}
          {(options || []).map(({ key, onClick, color, title, icon, width }) =>
            <Button topRight color={icon ? 'black' : color} key={key} onClick={onClick} style={width ? { width } : null}>
              {icon && <Icon src={icon} />}
              <div>{title}</div>
            </Button>
          )}
        </div>
      )}
    </ActionSheetsWrapper>
  ) : visible ? (
    <HorizontalCentered>
      <VerticalCentered>
        <ActionSheetsWrapper style={desktopStyle} onClick={e => e.stopPropagation()}>
          {loading ? (
            <Loading />
          ) : (
            <div>
              {title && <ButtonGroupHead>{title}</ButtonGroupHead>}
              {(options || []).map(({ key, onClick, color, title, icon, width }) =>
                <Button topRight={topRight} color={icon ? 'black' : color} key={key} onClick={onClick} style={width ? { width } : null}>
                  {icon && <Icon src={icon} />}
                  <div>{title}</div>
                </Button>
              )}
            </div>
          )}
          <BtnActionSheetsClose onClick={onCancel}>
            <IconClose src={svgClose} />
          </BtnActionSheetsClose>
        </ActionSheetsWrapper>
      </VerticalCentered>
    </HorizontalCentered>
  ) : null
}

const ActionSheetsWrapper = styled.div`
  @media(min-width: 768px) {
    border-radius: 5px;
    box-shadow: 0px 2px 2px rgba(173, 173, 173, 0.5);
    border: 1px solid ${getTheme`colorBorder`};
    background-color: white;
    max-width: 748px;
    width: 80vw;
    margin: 0 auto;
    padding: 30px 0px;
    position: relative;
    ${props => props.topRight && `
      position: absolute;
      width: 150px;
      top: 40px;
      right: 10px;
      padding: 0px;
      background-color: white;
    `}
  }
`
const ButtonGroupHead = styled.div`
  @media(max-width: 767px) {
    color: ${getTheme`colorGray`};
    font-size: 14px;
    line-height: 35px;
    height: 35px;
  }
  @media(min-width: 768px) {
    color: black;
    font-size: 20px;
    line-height: 35px;
    height: 35px;
    margin-bottom: 20px;
  }
`
const MobileButtons = styled.div`
  padding: 10px;
  position: fixed;
  z-index: 100000;
  left: 0px; right: 0px;
  transition: bottom 0.3s ease;
  ${props => props.visible ? `
    bottom: 0vh;  
  ` : `
    bottom: -100vh;
  `}
  @media(min-width: 768px) { display: none; }
`
const ButtonGroup = styled.div`
  background-color: ${getTheme`colorBackground`};
  text-align: center;
  border-radius: 5px;
  margin-bottom: 10px;
  > div { border-bottom: 1px solid ${getTheme`colorBorder`}; }
  &:last-child { > div { border-bottom: 0px; } }
`

const Button = styled.div`
  @media(max-width: 767px) {
    line-height: 50px;
    height: 50px;
    max-width: 480px;
    margin: 0 auto;
    background-color: ${getTheme`colorBackground`};
    text-align: center;
    border-radius: 5px;
    color: ${props => props.color ? (props.theme[props.color] || props.color) : props.theme.colorTiffanyDark};
    transition: background-color 0.3s ease;
    &:hover { background-color: rgba(255, 255, 255, 0.6); }
  }
  @media(min-width: 768px) {
    ${props => props.topRight ? `
      line-height: 50px;
      height: 50px;
      max-width: 480px;
      margin: 0 auto;
      background-color: ${props.theme.colorBackground};
      text-align: center;
      border-bottom: 1px solid ${props.theme.colorBorder};
      color: ${props => props.color ? (props.theme[props.color] || props.color) : props.theme.colorTiffanyDark};
      transition: background-color 0.3s ease;
      &:hover { background-color: rgba(255, 255, 255, 0.6); }
    ` : `
      border-radius: 5px;
      border: 1px dashed ${props.theme.colorBorder};
      padding: 30px;
      text-align: center;
      color: black;
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
      background-color white;
      transition: background-color 0.3s ease;
      &:hover { background-color: ${props.theme.colorBorder}; }
      margin-right: 15px;
      &:last-child { margin-right: 0px; }
    `}
  }
`
const Icon = styled.img`
  @media(min-width: 768px) {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    margin-bottom: 20px;
    display: block;
  }
  @media(max-width: 767px) {
    width: 24px;
    height: 24px;
    vertical-align: top;
    margin-top: 13px;
    margin-right: 10px;
  }
`
const BtnActionSheetsClose = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  cursor: pointer;
  width: 40px;
  height: 40px;
`

export class SlideupView extends Component {
  render () {
    return this.props.withoutOverlay ? (
      <RSlideupView {...this.props} />
    ) : (
      <Overlay visible={this.props.visible}>
        <RSlideupView {...this.props} />
      </Overlay>
    )
  }
}

const RSlideupView = ({ visible, viewType, title, onClose, noPadding, children }) => {
  return viewportWidth() < 768 ? (
    <SlideupViewContainer
      visible={visible}
      viewType={viewType || 'full'}
      onClick={e => e.stopPropagation()}>
      <ModalTitle>
        <span>{title}</span>
        <ModalClose onClick={onClose}>
          <IconClose src={svgClose} />
        </ModalClose>
      </ModalTitle>
      <SlideupViewBody noPadding={noPadding}>
        {children}
      </SlideupViewBody>
    </SlideupViewContainer>
  ) : visible ? (
    <HorizontalCentered>
      <VerticalCentered>
        <Modal auto style={{ height: 'calc(100vh - 20px)', overflow: 'auto' }}>
          <SlideupViewContainer visible={visible} onClick={e => e.stopPropagation()}>
            <ModalTitle>
              <span>{title}</span>
              <ModalClose onClick={onClose}>
                <IconClose src={svgClose} />
              </ModalClose>
            </ModalTitle>
            <SlideupViewBody noPadding={noPadding}>
              {children}
            </SlideupViewBody>
          </SlideupViewContainer>
        </Modal>
      </VerticalCentered>
    </HorizontalCentered>
  ) : null
}

const SlideupViewContainer = styled.div`
  @media(max-width: 767px) {
    background-color: white;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    top: ${props => !props.visible && '100vh'};
    transition: top 0.3s ease;
    position: fixed;
    left: 0px; right: 0px; bottom: 0px;
    z-index: 100000;
    ${props => props.viewType === 'compact' ? `
      top: ${props.visible ? 50 : 100}vh;
    ` : props.viewType === 'tall' ? `
      top: ${props.visible ? 25 : 100}vh;
    ` : props.viewType === 'full' && `
      top: ${props.visible ? '15px' : '100vh'};
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    `}
  }
  @media(min-width: 768px) {
    width: 480px;
    text-align: center;
  }
`
const ModalTitle = styled.div`
  line-height: 40px;
  height: 40px;
  border-bottom: 1px solid ${getTheme`colorBorder`};
  position: relative;
  > span {
    width: calc(100% - 80px);
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    overflow: hidden;
    margin: 0 auto;
  }
`
const ModalClose = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
`
const IconClose = styled.img`
  width: 16px;
  height: 16px;
  margin-top: 12px;
  vertical-align: top;
`
const SlideupViewBody = styled.div`
  @media(min-width: 768px) {
    padding: ${props => props.noPadding ? 0 : 20}px;
  }
  @media(max-width: 767px) {
    padding: ${props => props.noPadding ? 0 : 10}px;
  }
`

export class ConfirmDialog extends Component {
  render () {
    const { title, onCancel, onOkay, okayTitle, loading } = this.props
    return (
      <HorizontalCentered>
        <VerticalCentered>
          <ConfirmDialogWrapper onClick={e => e.stopPropagation()}>
            <ConfirmDialogTitle>{title}</ConfirmDialogTitle>
            <ConfirmDialogButtons>
              <ConfirmDialogButton onClick={onCancel}>ยกเลิก</ConfirmDialogButton>
              <ConfirmDialogButton onClick={onOkay}>
                {loading
                  ? <ConfirmDialogLoading src={svgLoadingTiffany} />
                  : <span>{okayTitle || 'ตกลง'}</span>
                }
              </ConfirmDialogButton>
            </ConfirmDialogButtons>
          </ConfirmDialogWrapper>
        </VerticalCentered>
      </HorizontalCentered>
    )
  }
}

const ConfirmDialogWrapper = styled.div`
  min-width: 200px;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  padding: 20px;
`
const ConfirmDialogTitle = styled.div`
  font-size: 16px;
  margin-bottom: 20px;
  text-align: left;
`
const ConfirmDialogButtons = styled.div`
  text-align: right;
`
const ConfirmDialogButton = styled.div`
  display: inline-block;
  vertical-align: top;
  min-width: 75px;
  text-align: center;
  color: ${getTheme`colorTiffanyDark`};
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
`
const ConfirmDialogLoading = styled.img`
  width: 20px;
  height: 20px;
  vertical-align: middle;
`



// WEBPACK FOOTER //
// ./src/components/Modal.js